import React from 'react';

import Location from '../images/location.svg';

const Cities = (props) => {
	console.log('New Cities', props)
  return (
    <div className="cities">
    	<div>
    		<h2>{props.title}</h2>
    		<div className="FooterIcons">
    			<i><img src={Location} alt=""/></i>
    			<p>{props.street}<br/><strong>{props.neigh}</strong> <br/> {props.phone}</p>
    		</div>
    	</div>
    </div>
  )
}

export default Cities;


// WEBPACK FOOTER //
// ./src/components/cities.js